import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Section = styled(Stack)`
  padding: 0 20px;
`;

export const WorkHoursTable = styled('table')`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px;
  overflow: hidden;

  thead {
    background: var(--dk-bg-subtle, #f9fafb);

    tr {
      th {
        padding: 8px;
        font-weight: 400;
        text-align: left;
        color: var(--dk-text, #000);
        border-bottom: 1px solid var(--dk-line, #e7e9ec);

        &:nth-of-type(1) {
          width: 30%;
        }

        &:nth-of-type(2) {
          width: 30%;
        }

        &:nth-of-type(3) {
          width: 28%;
        }

        &:last-of-type {
          width: 12%;
          padding: 8px;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 8px;
        color: var(--dk-text, #000);
        font-weight: inherit;
        text-align: left;
        border-bottom: 1px solid var(--dk-line, #e7e9ec);

        &:nth-of-type(1) {
          width: 30%;
        }

        &:nth-of-type(2) {
          width: 30%;
        }

        &:nth-of-type(3) {
          width: 28%;
        }

        &.link {
          text-decoration: underline;
          cursor: pointer;
        }

        &.action {
          width: 12%;
          padding: 8px;
          text-align: center;
        }
      }

      &:last-of-type td {
        border-bottom: none;
      }
    }
  }
`;
